export function getAnalyticsData(url: string, ctaValue: string, section?: string) {
    return {
        label: section ? `My design services:${section}` : 'Content:Design Services Dashboard tile',
        pageName: 'Design Services:Dashboard',
        pageSection: 'Design Services',
        pageStage: 'My Account',
        category: 'Design Services',
        eventDetail: `/graphic-design/dashboard;${url};${
            section ? 'My design services' : 'Design Services Dashboard tile'
        };${ctaValue}`,
    };
}
